import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Comparable from '../../../../../java/lang/Comparable';
var SweepLineEvent = /*#__PURE__*/function () {
  function SweepLineEvent() {
    _classCallCheck(this, SweepLineEvent);
    SweepLineEvent.constructor_.apply(this, arguments);
  }
  _createClass(SweepLineEvent, [{
    key: "isDelete",
    value: function isDelete() {
      return this._eventType === SweepLineEvent.DELETE;
    }
  }, {
    key: "setDeleteEventIndex",
    value: function setDeleteEventIndex(deleteEventIndex) {
      this._deleteEventIndex = deleteEventIndex;
    }
  }, {
    key: "getObject",
    value: function getObject() {
      return this._obj;
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var pe = o;
      if (this._xValue < pe._xValue) return -1;
      if (this._xValue > pe._xValue) return 1;
      if (this._eventType < pe._eventType) return -1;
      if (this._eventType > pe._eventType) return 1;
      return 0;
    }
  }, {
    key: "getInsertEvent",
    value: function getInsertEvent() {
      return this._insertEvent;
    }
  }, {
    key: "isInsert",
    value: function isInsert() {
      return this._eventType === SweepLineEvent.INSERT;
    }
  }, {
    key: "isSameLabel",
    value: function isSameLabel(ev) {
      if (this._label === null) return false;
      return this._label === ev._label;
    }
  }, {
    key: "getDeleteEventIndex",
    value: function getDeleteEventIndex() {
      return this._deleteEventIndex;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._label = null;
      this._xValue = null;
      this._eventType = null;
      this._insertEvent = null;
      this._deleteEventIndex = null;
      this._obj = null;
      if (arguments.length === 2) {
        var x = arguments[0],
          insertEvent = arguments[1];
        this._eventType = SweepLineEvent.DELETE;
        this._xValue = x;
        this._insertEvent = insertEvent;
      } else if (arguments.length === 3) {
        var label = arguments[0],
          _x = arguments[1],
          obj = arguments[2];
        this._eventType = SweepLineEvent.INSERT;
        this._label = label;
        this._xValue = _x;
        this._obj = obj;
      }
    }
  }]);
  return SweepLineEvent;
}();
export { SweepLineEvent as default };
SweepLineEvent.INSERT = 1;
SweepLineEvent.DELETE = 2;